var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Face'),_c('Losse'),_c('Lash'),_c('Harsen'),_c('GelPolish'),_c('GelNagels'),_c('Pedicure')],1)}
var staticRenderFns = []

export { render, staticRenderFns }